{
  "__localization_test_string": "您已达到 {{time_period}}对该提供商的最大访问次数。您下次可从 {{start_date}}开始访问该提供商。",
  "app_name": "Plentiful",
  "app_button_ok": "好的",
  "app_button_cancel": "取消",
  "app_button_yes": "是的",
  "app_button_no": "不",
  "app_button_confirm": "确认",
  "app_button_try_again": "再试一次",
  "rate_the_app": "为 Plentiful 评分",
  "app_textview_somethingwentwrong": "出了点问题！\n请重试",
  "app_button_logout": "登出",
  "app_today": "今天",
  "app_dialog_clarify_prompt": "你确定吗？",
  "app_personal_edittext_phone": "电话号码",
  "app_personal_edittext_dob": "出生日期（可选）",
  "app_personal_edittext_firstname": "名",
  "app_personal_edittext_lastname": "姓",
  "app_personal_edittext_zipcode": "邮政编码",
  "app_pantrykind_food": "食品储藏室",
  "app_servicekind_reservations": "保留",
  "app_servicekind_line": "线",
  "distribution_schedule": "分发时间表",
  "service_type_no_digital_options": "仅限排队",
  "service_type_reservation_inline": "可预约",
  "service_type_allows_pre_registration": "允许预注册",
  "app_locationnotavailable": "位置不可用",
  "app_generalerror": "错误",
  "app_dialog_loading": "加载。请稍等…",
  "app_dialog_sms_code_title": "短信代码",
  "app_dialog_sms_code_button_send_new_code": "发送一个新代码",
  "app_release_id": "应用程序发布标识符",
  "sms_disclaimer": "可能会收取短信和数据费用。发送STOP退订。",
  "fragment_registration_language_textview_title": "选择您喜欢的语言开始",
  "fragment_registration_language_button_next": "下一个",
  "fragment_registration_family_textview_title": "告诉我们您的家庭情况",
  "fragment_registration_family_textview_adults": "成年人数量（18-{{senior_age_threshold_minus_one}}岁）",
  "fragment_registration_family_textview_children": "儿童人数（18岁以下）",
  "fragment_registration_family_textview_seniors": "老年人口（{{senior_age_threshold}}岁以上）数量",
  "fragment_registration_family_textview_notetitle": "笔记：",
  "fragment_registration_family_textview_notecontent": "请提供您的家庭详细信息，以便我们更好地为您服务。请注意：您自己不包括在您上面列出的家庭成员人数中。",
  "fragment_registration_family_button_back": "后退",
  "fragment_registration_family_button_next": "下一个",
  "fragment_registration_personal_textview_title": "欢迎来到您的 Plentyful 个人资料",
  "fragment_registration_personal_button_back": "后退",
  "fragment_registration_personal_button_finish": "结束",
  "fragment_main_tabitem_pantrymap": "地图",
  "fragment_main_tabitem_pantrylist": "列表",
  "fragment_main_bottombar_pantries": "裤子",
  "fragment_main_bottombar_visits": "访问",
  "fragment_main_bottombar_messages": "消息",
  "fragment_main_bottombar_profile": "轮廓",
  "cell_pantry_short_visit_date": "你去了",
  "fragment_pantrydetail_button_changetime": "更改时间",
  "fragment_pantrydetail_textview_amenities": "设施",
  "fragment_pantrydetail_textview_conditions": "条件",
  "fragment_pantrydetail_textview_notes": "食品室笔记",
  "fragment_pantrydetail_edittext_message": "信息…",
  "fragment_pantrydetail_button_createreservation": "安排参观",
  "fragment_pantrydetail_button_schedulevisit": "安排参观",
  "dialog_visittime_textview_nodatesavailable": "没有可用的日期",
  "fragment_visitlist_textview_title": "访问",
  "fragment_visitlist_textview_zero": "这是您可以管理即将到来的服务时间的地方。找到一个食品室安排参观！",
  "fragment_messagethreadlist_textview_title": "消息",
  "fragment_messagethreadlist_textview_zero": "尚无更新！\n要订阅更新，请转到您最喜欢的食品储藏室的详细信息页面，然后切换页面底部的“从此食品储藏室获取更新”。",
  "fragment_profile_textview_title": "轮廓",
  "fragment_profile_button_savechanges": "保存更改",
  "fragment_profile_textview_personaldetails": "个人资料",
  "fragment_profile_textview_language": "语言",
  "fragment_profile_textview_notifications": "通知",
  "fragment_profile_switch_receivenotifications": "推送通知",
  "receive_notifications_helper": "在您的设备上接收提醒",
  "fragment_profile_textview_servicedetails": "服务细节",
  "fragment_profile_switch_pickupfood": "我让别人帮我取食物",
  "fragment_profile_edittext_pickupname": "取货代表姓名",
  "fragment_profile_edittext_pickupphone": "取货代表电话号码",
  "textview_baby_supplies": "您需要多少个孩子的婴儿用品（纸尿裤、湿巾、奶粉）",
  "fragment_profile_textview_emergencycontact": "紧急联系人",
  "fragment_profile_edittext_emergencyname": "紧急联系人名字和姓氏",
  "fragment_profile_edittext_emergencyphone": "紧急联系电话",
  "aiq_validation_error_regex_telephone_us": "电话号码格式不正确",
  "fragment_profile_textview_changepersonalinfo": "此信息可在任何丰富的食品储藏室内更新。",
  "fragment_profile_edittext_feedback": "回馈…",
  "fragment_profile_toast_feedbacksent": "反馈发送",
  "baby_supplies": "婴儿用品",
  "household_size": "房子大小",
  "food_pickup": "食物领取",
  "emergency_contact": "紧急联系人",
  "dialog_app_update_title": "更新可用",
  "dialog_app_update_message": "Google Play Store中提供的下一个版本的应用程序！",
  "dialog_app_update_button_openplaystore": "开放播放商店",
  "app_invalid_error": "无效的",
  "no_pantries_available": "未找到结果。请尝试使用其他食品储藏室名称进行搜索，或清空搜索框并移动或缩小地图，以探索拥有丰富食品储藏室的区域。",
  "visit_served": "服务",
  "visit_not_served": "不服用",
  "visit_no_show": "你没有出现",
  "visit_group": "您在 {{group_number}}群组，请来 {{time}}",
  "visit_pre_registered": "您已预先注册，请加入 {{from_time}} - {{end_time}}之间的队伍",
  "pick_visit_time": "选择访问时间",
  "received_service_on": "您访问过",
  "service_starts_at": "服务开始",
  "cancel_visit": "取消访问",
  "confirm_cancel_visit": "您确定要取消访问吗？",
  "yes_cancel": "是的，取消",
  "send": "发送",
  "reservations_available": "当我可以预约访问时提醒我",
  "service_notification_error": "更新通知偏好设置时出现问题。请重试。仍然遇到问题？点击个人资料，然后点击我们随时为您服务以联系支持团队。",
  "report_location_issue": "报告此位置的问题",
  "registration_intro": "欢迎来到 Plentiful！我们在这里帮您找到附近的食物救济站。",
  "app_personal_edittext_enter_phone": "输入你的电话号码",
  "code_sent_to": "短信登录代码已发送至",
  "account_created": "帐户已创建",
  "get_started": "让我们开始吧！",
  "additional_details": "附加信息",
  "your_qr_code": "你的最新通行证",
  "id_number": "身份证号码",
  "personal_details_extra": "个人信息和偏好",
  "settings": "设置",
  "settings_extra": "语言和通知设置",
  "not_verified": "尚未验证",
  "must_be_reverified_by": "必须崇敬",
  "last_verified_on": "上次验证了",
  "at": "在",
  "no_visit_options_available": "目前没有可供您使用的访问选项。请检查食品储藏室的状况或联系食品储藏室。",
  "need_help": "需要帮忙？",
  "email": "电子邮件",
  "terms_conditions": "最终用户协议",
  "privacy_policy": "隐私政策",
  "updates": "更新",
  "family_details": "家庭详情",
  "welcome_to_plentiful": "欢迎愉快！",
  "enter_email_phone": "注册后，您可以预订并接收您访问的食品储藏室的最新消息。\n如果您在食品储藏室注册过，请使用相同的电话号码或电子邮件。 \n需要帮助？请通过 support@plentiful.org 联系我们。",
  "email_or_phone": "手机号码或电子邮件地址",
  "email_address": "电子邮件地址",
  "enter_email": "输入你的电子邮箱",
  "address": "地址",
  "email_invalid": "电子邮件地址无效",
  "no_sms_enabled_phone": "电话号码无法接收短信",
  "verification_email_sent": "验证电子邮件发送！",
  "check_verification_email": "检查你的电子邮件并点击里面的按钮来验证你的帐户",
  "email_verification_sent": "我们已向您发送了一封电子邮件。请点击邮件中的按钮来验证您的电子邮件地址。",
  "email_address_purpose": "接收来自 Plentiful 的访问提醒和重要更新",
  "sign_up": "报名",
  "sign_in": "登入",
  "continue": "继续",
  "create_password": "创建密码",
  "enter_password": "请输入您的密码以登录",
  "password_info_box": "如果您忘记了密码，或者您在食品储藏室注册时没有设置密码，那么请使用以下选项以魔法方式登录或重置密码。",
  "reset_password": "重设密码",
  "password": "密码",
  "eight_characters": "至少8个字符",
  "one_special_character": "至少有1个特殊性",
  "one_number": "至少一个数字",
  "submit": "提交",
  "send_magic_link": "发送魔法链接",
  "magic_link_sent": "一个魔法链接正在前往您的收件箱。",
  "confirm_magic_link_login": "确认魔术链接登录",
  "sign_in_another_way": "换句话说",
  "enter_phone": "请输入您的电话号码",
  "skip": "跳过",
  "optional": "选修的",
  "enter_activation_code": "请输入您的登录代码",
  "activation_code": "登录代码",
  "accept_eula": "我已阅读并同意使用条款和隐私",
  "email_verified": "电子邮件已验证",
  "email_verified_details": "您的电子邮件地址现已验证。",
  "do_not_ask_again": "不再询问。",
  "email_in_use": "我们已经拥有与此电子邮件相关的帐户。请使用其他电子邮件",
  "reset_password_text": "请输入您的电子邮件以重置密码",
  "reset_password_sent": "重置密码电子邮件发送！",
  "reset_password_sent_text": "如果我们在文件中有一个帐户{{email}}，我们已发送链接以重置密码，",
  "dob_required": "出生日期",
  "please_verify": "请在个人资料中验证电话或电子邮件",
  "open_profile": "开放式",
  "send_another_verification_email": "发送另一个验证电子邮件",
  "need_to_change_email": "如果您需要更改您的电子邮件地址，请联系 support@plentifulapp.com。",
  "need_to_change_email_or_phone": "如果您需要更改您的电子邮件地址或电话号码，请联系 support@plentifulapp.com。",
  "need_to_change_phone": "如果您需要更改您的电话号码，请联系support@plentifulapp.com或参观储藏室。",
  "email_subscription": "电子邮件订阅",
  "email_subscribed": "电子邮件订阅",
  "email_unsubscribed": "电子邮件取消订阅",
  "email_subscribed_text": "您现在已经订阅了{{email}}的信息",
  "email_unsubscribed_text": "您现在从丰富的电子邮件中取消订阅{{eament}}",
  "here_to_subscribe": "点击这里订阅丰富的电子邮件",
  "here_to_unsubscribe": "点击此处取消订阅丰富的电子邮件",
  "unsubscribe": "取消订阅",
  "subscribe": "订阅",
  "open_profile_text": "点击这里转到您的个人资料",
  "sign_in_text": "点击此处登录",
  "phone_assigned": "此电话号码已在使用中。输入另一个电话号码或使用此电话号码返回并登录。",
  "email_subscribe": "邮件更新",
  "email_subscribe_helper": "来自您访问的食品储藏室和Plentiful的邮件",
  "message_preferences": "消息偏好",
  "message_preferences_description": "您希望如何接收访问提醒和更新？",
  "message_method_option_0": "邮件和应用通知",
  "message_method_option_1": "优先短信",
  "message_method_helper_add_phone": "添加您的手机号码以接收短信",
  "message_method_helper_sms_opt_in": "发送'START'到PANTRY (726-879) 以重新接收短信",
  "message_method_helper_add_email": "添加您的邮箱以接收邮件",
  "message_method_helper_email_unsub": "您已取消订阅邮件。更新您的邮件偏好以接收邮件。",
  "message_method_helper_add_push": "下载手机应用以接收推送通知",
  "message_method_helper_enable_push": "在设备设置中启用通知以接收推送通知",
  "password_error": "密码错误。再试一次，重置密码，或以另一种方式签名",
  "action_required": "需要采取的行动",
  "otp_error": "无法验证代码",
  "show_more": "显示更多",
  "pre_registration": "登记",
  "show_less": "显示较少",
  "reschedule": "改期",
  "view_pantry": "查看食品储藏室详细信息",
  "next_service_on": "下一个服务",
  "add_birthday": "添加您的生日以解锁您的 Plenti-Pass",
  "birthday_required": "使用此通行证可以快速、轻松地在食品储藏室办理入住手续。",
  "missed_reservation_on": "你错过了你的预订",
  "delete_account": "删除帐户",
  "delete_explain": "您确定要删除您的帐户吗？这将取消所有即将进行的食品储藏室访问并删除您的帐户。您需要重新注册才能使用 Plentiful。",
  "yes_delete": "是，删除",
  "no_cancel": "不，取消",
  "select_visit_reschedule": "选择要重新安排的访问",
  "select_visit_cancel": "选择您要取消的访问",
  "search_pantries": "搜索裤子",
  "please_sign_in_or_up": "你需要一个充实的帐户来继续。丰富完全可自由使用。",
  "sign_in_or_up": "登录或注册以继续",
  "country_of_birth_option_AF": "阿富汗",
  "country_of_birth_option_AX": "Åland群岛",
  "country_of_birth_option_AL": "阿尔巴尼亚",
  "country_of_birth_option_DZ": "阿尔及利亚",
  "country_of_birth_option_AS": "美国萨摩亚",
  "country_of_birth_option_AD": "安道尔",
  "country_of_birth_option_AO": "安哥拉",
  "country_of_birth_option_AI": "安圭拉",
  "country_of_birth_option_AQ": "南极洲",
  "country_of_birth_option_AG": "安提瓜和巴布达",
  "country_of_birth_option_AR": "阿根廷",
  "country_of_birth_option_AM": "亚美尼亚",
  "country_of_birth_option_AW": "阿鲁巴",
  "country_of_birth_option_AU": "澳大利亚",
  "country_of_birth_option_AT": "奥地利",
  "country_of_birth_option_AZ": "阿塞拜疆",
  "country_of_birth_option_BS": "巴哈马",
  "country_of_birth_option_BH": "巴林",
  "country_of_birth_option_BD": "孟加拉国",
  "country_of_birth_option_BB": "巴巴多斯",
  "country_of_birth_option_BY": "白俄罗斯",
  "country_of_birth_option_BE": "比利时",
  "country_of_birth_option_BZ": "伯利兹",
  "country_of_birth_option_BJ": "贝宁",
  "country_of_birth_option_BM": "百慕大",
  "country_of_birth_option_BT": "不丹",
  "country_of_birth_option_BO": "玻利维亚",
  "country_of_birth_option_BA": "波斯尼亚和黑塞哥维那",
  "country_of_birth_option_BW": "博茨瓦纳",
  "country_of_birth_option_BV": "灌木岛",
  "country_of_birth_option_BR": "巴西",
  "country_of_birth_option_IO": "英属印度洋领地",
  "country_of_birth_option_BN": "文莱达鲁萨兰国",
  "country_of_birth_option_BG": "保加利亚",
  "country_of_birth_option_BF": "布基纳法索",
  "country_of_birth_option_BI": "布隆迪",
  "country_of_birth_option_KH": "柬埔寨",
  "country_of_birth_option_CM": "喀麦隆",
  "country_of_birth_option_CA": "加拿大",
  "country_of_birth_option_CV": "佛得角",
  "country_of_birth_option_KY": "五. 开曼群岛",
  "country_of_birth_option_CF": "中非共和国",
  "country_of_birth_option_TD": "乍得",
  "country_of_birth_option_CL": "智利",
  "country_of_birth_option_CN": "中国",
  "country_of_birth_option_CX": "圣诞岛",
  "country_of_birth_option_CC": "Cocos（龙骨）群岛",
  "country_of_birth_option_CO": "哥伦比亚",
  "country_of_birth_option_KM": "科摩罗",
  "country_of_birth_option_CG": "刚果",
  "country_of_birth_option_CD": "刚果，民主共和国",
  "country_of_birth_option_CK": "库克群岛",
  "country_of_birth_option_CR": "哥斯达黎加",
  "country_of_birth_option_CI": "科特迪瓦的ivoire",
  "country_of_birth_option_HR": "克罗地亚",
  "country_of_birth_option_CU": "古巴",
  "country_of_birth_option_CY": "塞浦路斯",
  "country_of_birth_option_CZ": "捷克共和国",
  "country_of_birth_option_DK": "丹麦",
  "country_of_birth_option_DJ": "吉布提",
  "country_of_birth_option_DM": "多米尼克",
  "country_of_birth_option_DO": "多米尼加共和国",
  "country_of_birth_option_EC": "厄瓜多尔",
  "country_of_birth_option_EG": "埃及",
  "country_of_birth_option_SV": "萨尔瓦多",
  "country_of_birth_option_GQ": "Guinea Ecuatorial",
  "country_of_birth_option_ER": "厄立特里亚",
  "country_of_birth_option_EE": "爱沙尼亚",
  "country_of_birth_option_ET": "埃塞俄比亚",
  "country_of_birth_option_FK": "福克兰群岛（Malvinas）",
  "country_of_birth_option_FO": "法罗群岛",
  "country_of_birth_option_FJ": "斐济",
  "country_of_birth_option_FI": "芬兰",
  "country_of_birth_option_FR": "法国",
  "country_of_birth_option_GF": "法属圭亚那a",
  "country_of_birth_option_PF": "法国波利尼西亚",
  "country_of_birth_option_TF": "法国南部领土",
  "country_of_birth_option_GA": "加蓬",
  "country_of_birth_option_GM": "冈比亚",
  "country_of_birth_option_GE": "乔治亚州",
  "country_of_birth_option_DE": "德国",
  "country_of_birth_option_GH": "加纳",
  "country_of_birth_option_GI": "直布罗陀问题",
  "country_of_birth_option_GR": "希腊",
  "country_of_birth_option_GL": "格陵兰岛",
  "country_of_birth_option_GD": "格林纳达",
  "country_of_birth_option_GP": "瓜德罗普",
  "country_of_birth_option_GU": "六. 关岛",
  "country_of_birth_option_GT": "危地马拉",
  "country_of_birth_option_GG": "根西岛",
  "country_of_birth_option_GN": "几内亚",
  "country_of_birth_option_GW": "几内亚比绍",
  "country_of_birth_option_GY": "Гайана",
  "country_of_birth_option_HT": "海地",
  "country_of_birth_option_HM": "听到岛屿和麦当劳群岛",
  "country_of_birth_option_VA": "圣洁（梵蒂冈市州）",
  "country_of_birth_option_HN": "洪都拉斯",
  "country_of_birth_option_HK": "ong Kong",
  "country_of_birth_option_HU": "匈牙利",
  "country_of_birth_option_IS": "冰岛",
  "country_of_birth_option_IN": "印度",
  "country_of_birth_option_ID": "印度尼西亚",
  "country_of_birth_option_IR": "伊朗，伊斯兰共和国",
  "country_of_birth_option_IQ": "伊拉克",
  "country_of_birth_option_IE": "爱尔兰",
  "country_of_birth_option_IM": "伊斯勒人",
  "country_of_birth_option_IL": "以色列",
  "country_of_birth_option_IT": "意大利",
  "country_of_birth_option_JM": "牙买加",
  "country_of_birth_option_JP": "日本",
  "country_of_birth_option_JE": "泽西岛",
  "country_of_birth_option_JO": "约旦",
  "country_of_birth_option_KZ": "哈萨克斯坦",
  "country_of_birth_option_KE": "肯尼亚",
  "country_of_birth_option_KI": "基里巴斯",
  "country_of_birth_option_KP": "韩国民主党人的共和国",
  "country_of_birth_option_KR": "韩国，共和国",
  "country_of_birth_option_KW": "科威特",
  "country_of_birth_option_KG": "吉尔吉斯斯坦",
  "country_of_birth_option_LA": "老挝人民民主共和国",
  "country_of_birth_option_LV": "拉脱维亚",
  "country_of_birth_option_LB": "黎巴嫩",
  "country_of_birth_option_LS": "莱索托",
  "country_of_birth_option_LR": "利比里亚",
  "country_of_birth_option_LY": "利比亚阿拉伯Jamahiriya.",
  "country_of_birth_option_LI": "列支敦士登",
  "country_of_birth_option_LT": "立陶宛",
  "country_of_birth_option_LU": "卢森堡",
  "country_of_birth_option_MO": "澳门",
  "country_of_birth_option_MK": "马其顿，前南斯拉夫共和国",
  "country_of_birth_option_MG": "马达加斯加",
  "country_of_birth_option_MW": "马拉维",
  "country_of_birth_option_MY": "马来西亚",
  "country_of_birth_option_MV": "马尔代夫",
  "country_of_birth_option_ML": "马里",
  "country_of_birth_option_MT": "马耳他",
  "country_of_birth_option_MH": "马歇尔群岛",
  "country_of_birth_option_MQ": "马提尼克岛",
  "country_of_birth_option_MR": "毛里塔尼亚",
  "country_of_birth_option_MU": "毛里求斯",
  "country_of_birth_option_YT": "Mostote.",
  "country_of_birth_option_MX": "墨西哥",
  "country_of_birth_option_FM": "密克罗尼西亚，联邦州",
  "country_of_birth_option_MD": "摩尔多瓦，共和国",
  "country_of_birth_option_MC": "摩纳哥",
  "country_of_birth_option_MN": "蒙古",
  "country_of_birth_option_MS": "蒙特塞拉特",
  "country_of_birth_option_MA": "摩洛哥",
  "country_of_birth_option_MZ": "莫桑比克",
  "country_of_birth_option_MM": "缅甸",
  "country_of_birth_option_NA": "纳米比亚",
  "country_of_birth_option_NR": "瑙鲁",
  "country_of_birth_option_NP": "尼泊尔",
  "country_of_birth_option_NL": "荷兰",
  "country_of_birth_option_AN": "荷属安的列斯群岛",
  "country_of_birth_option_NC": "B. 新喀里多尼亚问题",
  "country_of_birth_option_NZ": "新西兰",
  "country_of_birth_option_NI": "尼加拉瓜",
  "country_of_birth_option_NE": "尼日尔",
  "country_of_birth_option_NG": "尼日利亚",
  "country_of_birth_option_NU": "纽埃",
  "country_of_birth_option_NF": "诺福尔克岛",
  "country_of_birth_option_MP": "北马里亚纳群岛",
  "country_of_birth_option_NO": "挪威",
  "country_of_birth_option_OM": "阿曼",
  "country_of_birth_option_PK": "巴基斯坦",
  "country_of_birth_option_PW": "帕劳",
  "country_of_birth_option_PS": "巴勒斯坦领土，被占领",
  "country_of_birth_option_PA": "巴拿马",
  "country_of_birth_option_PG": "巴布亚新几内亚",
  "country_of_birth_option_PY": "巴拉圭",
  "country_of_birth_option_PE": "秘鲁",
  "country_of_birth_option_PH": "菲律宾",
  "country_of_birth_option_PN": "Pitcairn.",
  "country_of_birth_option_PL": "波兰",
  "country_of_birth_option_PT": "葡萄牙",
  "country_of_birth_option_PR": "波多黎各",
  "country_of_birth_option_QA": "卡塔尔",
  "country_of_birth_option_RE": "团圆",
  "country_of_birth_option_RO": "罗马尼亚",
  "country_of_birth_option_RU": "俄语",
  "country_of_birth_option_RW": "卢旺达",
  "country_of_birth_option_SH": "圣海伦娜",
  "country_of_birth_option_KN": "圣基茨和尼维斯",
  "country_of_birth_option_LC": "圣卢西亚",
  "country_of_birth_option_PM": "圣皮埃尔和米利克",
  "country_of_birth_option_VC": "圣文森特和格林纳丁斯",
  "country_of_birth_option_WS": "萨摩亚",
  "country_of_birth_option_SM": "圣马力诺",
  "country_of_birth_option_ST": "圣多美和普林西比",
  "country_of_birth_option_SA": "沙特阿拉伯",
  "country_of_birth_option_SN": "塞内加尔",
  "country_of_birth_option_CS": "塞尔维亚和黑山",
  "country_of_birth_option_SC": "塞舌尔",
  "country_of_birth_option_SL": "塞拉利昂",
  "country_of_birth_option_SG": "新加坡",
  "country_of_birth_option_SK": "斯洛伐克",
  "country_of_birth_option_SI": "斯洛文尼亚",
  "country_of_birth_option_SB": "所罗门群岛",
  "country_of_birth_option_SO": "索马里",
  "country_of_birth_option_ZA": "南非",
  "country_of_birth_option_GS": "南乔治亚和南三明治群岛",
  "country_of_birth_option_ES": "西班牙",
  "country_of_birth_option_LK": "斯里兰卡",
  "country_of_birth_option_SD": "苏丹",
  "country_of_birth_option_SR": "苏里南",
  "country_of_birth_option_SJ": "Svalbard和Jan Mayen",
  "country_of_birth_option_SZ": "斯威士兰",
  "country_of_birth_option_SE": "瑞典",
  "country_of_birth_option_CH": "瑞士",
  "country_of_birth_option_SY": "阿拉伯叙利亚共和国",
  "country_of_birth_option_TW": "台湾，中国省",
  "country_of_birth_option_TJ": "塔吉克斯坦",
  "country_of_birth_option_TZ": "坦桑尼亚，联合共和国",
  "country_of_birth_option_TH": "泰国",
  "country_of_birth_option_TL": "Timor-Leste.",
  "country_of_birth_option_TG": "多哥",
  "country_of_birth_option_TK": "托克劳",
  "country_of_birth_option_TO": "汤加",
  "country_of_birth_option_TT": "特立尼达和多巴哥",
  "country_of_birth_option_TN": "突尼斯",
  "country_of_birth_option_TR": "火鸡",
  "country_of_birth_option_TM": "土库曼斯坦",
  "country_of_birth_option_TC": "特克斯和凯科斯群岛",
  "country_of_birth_option_TV": "图瓦卢",
  "country_of_birth_option_UG": "乌干达",
  "country_of_birth_option_UA": "乌克兰",
  "country_of_birth_option_AE": "阿拉伯联合酋长国",
  "country_of_birth_option_GB": "英国",
  "country_of_birth_option_US": "美国",
  "country_of_birth_option_UM": "美国未成年野外岛屿",
  "country_of_birth_option_UY": "乌拉圭",
  "country_of_birth_option_UZ": "乌兹别克斯坦",
  "country_of_birth_option_VU": "瓦努阿图",
  "country_of_birth_option_VE": "委内瑞拉",
  "country_of_birth_option_VN": "越南",
  "country_of_birth_option_VG": "维尔京群岛，英国",
  "country_of_birth_option_VI": "维尔京群岛，美国",
  "country_of_birth_option_WF": "瓦利斯和福纳",
  "country_of_birth_option_EH": "撒哈拉沙漠西部",
  "country_of_birth_option_YE": "也门",
  "country_of_birth_option_ZM": "赞比亚",
  "country_of_birth_option_ZW": "津巴布韦",
  "gender_option_female": "女性",
  "gender_option_male": "男性",
  "gender_option_nonconf": "性别不合格",
  "relationship_status_option_single": "单身的",
  "relationship_status_option_domestic_partner": "国内的合作伙伴",
  "relationship_status_option_common_law": "普通法",
  "relationship_status_option_emancipated_minor": "解放的未成年人",
  "relationship_status_option_married": "已婚",
  "relationship_status_option_divorced": "离婚",
  "relationship_status_option_separated": "分开",
  "relationship_status_option_widowed": "寡",
  "housing_option_own": "自己的",
  "housing_option_room_in_apartment": "公寓房间",
  "housing_option_friends_or_family": "朋友或家人",
  "housing_option_regular_rent": "常规租金",
  "housing_option_subsidized_rent": "补贴租金",
  "housing_option_shelter": "庇护所",
  "housing_option_homeless": "无家可归",
  "employment_option_full_time": "全职",
  "employment_option_part_time": "兼职",
  "employment_option_unemployed": "失业者",
  "education_option_no_high_school": "没有高中",
  "education_option_high_school_diploma": "高中毕业文凭",
  "education_option_ged": "g",
  "education_option_associate_or_bachelo": "员工或单身学士学位",
  "education_option_post_graduate": "研究生研究",
  "ethnicity_option_two_or_more_races": "两个或更多种比赛",
  "ethnicity_option_black": "黑色（非西班牙裔",
  "ethnicity_option_white": "白色（非西班牙裔",
  "ethnicity_option_hispanic_or_latino": "西班牙裔或拉丁裔",
  "ethnicity_option_asian_or_pacific": "亚洲或太平洋岛民",
  "ethnicity_option_american_indian_or_alaskan": "美洲印第安人或阿拉斯加",
  "ethnicity_option_other": "其他",
  "snap_benefits": "补充营养援助计划",
  "wic_benefits": "妇女，婴儿和儿童的补充营养计划",
  "tanf_benefits": "对贫困家庭的临时援助",
  "medicaid_benefits": "收入低收入的人的公共卫生保险",
  "ssi_benefits": "补充安全收入计划",
  "free_reduced_meals": "免费或减少膳食计划",
  "tefap_form": "TEFAP认证",
  "tefap_form_expired": "你的tefap证明已过期",
  "tefap_form_usda_title": "美国农业部非歧视声明",
  "tefap_form_usda_subheader": "请注意以下事项",
  "tefap_form_usda_body": "<p>根据联邦民权法和美国农业部 (USDA) 的民权法规政策，美国农业部及其机构、办公处和雇员，以及参与或管理美国农业部项目的机构，在美国农业部及其资助的任何项目及活动中，不得存在因种族、肤色、国籍、性别、残障，年龄而进行的区别对待，不得对以前的民权运动进行报复。</p><p>需要其它沟通方式（盲文、大字、录音带、美国手语等）以获取项目信息的残障人士，请联系递交受援申请的州或地方机构。失聪、有听力障碍或语言障碍的人士请通过通过联邦中继服务电话 (800) 877-8339 联系美国农业部。此外，本项目信息也以英语以外的语言呈现。</p><p>如您遭遇歧视或不公对待，需要投诉，请填写美国农业部投诉歧视表 (AD-3027) 在线投诉地址：<a href=\"https://www.usda.gov/oascr/how-to-file-a-program-discrimination-complaint\">如何投诉</a>；也可在美国农业部的任何办公室进行投诉，或者写信给美国农业部，并在信中提供表格要求的所有信息。索取投诉表格副本，请拨打电话 (866) 632-9992。您可通过以下方式将填写完整的表格提交至美国农业部：</p><p>(1) 邮件地址：美国农业部<br>人权事务助理秘书长办公室<br>华盛顿特区西南独立大道 1400<br>号邮编：20250-9410；</p><p>(2) 传真：(202) 690-7442；</p><p>(3) 或电子邮件：program.intake@usda.gov。</p><p>本机构所提供的机会不对特定人群倾斜。</p>",
  "app_button_next": "下一个",
  "app_button_back": "后退",
  "app_button_submit": "提交",
  "app_button_close": "关闭",
  "app_button_done": "完成",
  "form_required": "必需的 *",
  "benefits": "福利计划",
  "benefits_extra": "关于福利计划的详细信息",
  "help_and_support": "我们随时为您提供帮助",
  "help_and_support_extra": "常见问题和联系信息",
  "frequently_asked_questions": "常见问题",
  "contact_support": "联系众多支持",
  "optional_details": "可选的详细信息",
  "address_street_1": "地址",
  "address_street_2": "易于",
  "city": "城市",
  "state": "状态",
  "zipcode": "邮政编码",
  "additional_optional_details": "额外细节",
  "gender": "性别",
  "relationship_status": "关系状态",
  "ethnicity": "种族",
  "country_of_birth": "出生国",
  "employment": "就业",
  "highest_education_obtained": "教育",
  "food_preferences": "食物偏好",
  "housing_details": "住房细节",
  "housing_status": "住房状况",
  "special_circumstances": "特殊的情况",
  "needs_assistance": "我需要在裤子上提供帮助",
  "dont_need_assistance": "我不需要裤子的帮助",
  "aiq_validation_error_min_adult_family_members": "成年家庭成员必须大于 0",
  "aiq_validation_error_max_adult_family_members": "成年家庭成员不得超过 10 人",
  "aiq_validation_error_min_child_family_members": "儿童家庭成员必须大于 0",
  "aiq_validation_error_max_child_family_members": "儿童家庭成员不能超过 10 人",
  "aiq_validation_error_min_senior_family_members": "老年家庭成员必须大于 0",
  "aiq_validation_error_max_senior_family_members": "高级家庭成员不得超过 10 人",
  "aiq_validation_error_required_emergency_contact": "需要紧急联系人信息",
  "aiq_validation_error_required_pick_up_name": "提取代表名称信息是必需的",
  "aiq_validation_error_required_birth_date": "出生日期信息是必需的",
  "aiq_validation_error_regex_zip_code": "邮编必须是数字",
  "aiq_validation_error_required_first_name": "必须填写名字",
  "aiq_validation_error_required_last_name": "姓是必填项",
  "aiq_validation_error_min_baby_supplies": "婴儿供应必须大于 0",
  "aiq_validation_error_max_baby_supplies": "婴儿供应不能超过 10",
  "dietary_preferences_option_lactose": "乳糖不耐症",
  "dietary_preferences_option_gluten": "麸质不耐受",
  "dietary_preferences_option_kosher": "犹太犹太人",
  "dietary_preferences_option_halal": "清真",
  "dietary_preferences_option_dairy_free": "乳制品免费",
  "dietary_preferences_option_vegetarian": "素食者",
  "dietary_preferences_option_vegan": "素食主义者",
  "dietary_preferences_option_fodmap": "FODMAP.",
  "dietary_preferences_option_nut_allergy": "树坚果和花生过敏",
  "dietary_preferences_option_fish_allergy": "鱼和贝类过敏",
  "dietary_preferences_option_none": "没有偏好",
  "tefap_additional_info_requested": "请求其他信息",
  "tefap_zipcode_correct": "您的邮政编码是否正确？",
  "tefap_address_correct": "您的地址正确吗？",
  "tefap_participate_in_programs": "您家中的任何人是否参加了以下任何课程？",
  "tefap_check_all_that_apply": "请选择所有适用的选项。 如果没有，请点击“下一步”以获取更多选项。",
  "tefap_household_numbers_correct": "您家中的人数是否正确？",
  "tefap_household_dont_include_yourself": "请不要将您自己包含在此屏幕上。 TEFAP 仅需要您的家庭总规模，但 Plentiful 会显示您之前提供的信息。v",
  "tefap_income_at_or_below_question": "是您或以下收入",
  "tefap_for_household_size": "对于你的家庭",
  "tefap_retake_attestation": "你想重试认证吗？",
  "tefap_attestation_completed": "您已成功完成了TEFAP认证表格。",
  "tefap_thank_you": "谢谢！",
  "tefap_is_recorded": "您的TEFAP认证已被记录。您可以在您的个人资料中重新删除它。",
  "tefap_sign_below": "你的姓名（可选）",
  "tefap_legal_signing": "通过签署下文，我声明，我的所有来源的收入不超过上面与我家庭相同的家庭列出的收入，或者我的家庭参加了我在此表格上检查的计划。我明白，这些记录将充满信心地在这个分销现场举行，但可能会发布给纽约州的一般服务办事处或美国农业部审查其要求。",
  "tefap_retake": "重拍",
  "program_complete_now": "现在完成",
  "program_complete_later": "稍后完成",
  "reservation_confirmed": "访问确认",
  "tefap_reservation_confirmed": "您的来访已确认！",
  "pre_registration_confirmed": "访问确认",
  "your_upcoming_reservation": "您即将到来的访问",
  "your_upcoming_pre_registration": "您即将到来的访问",
  "tefap_attestation_needed": "这个食品室要求您的TEFAP认证。",
  "tefap_attestation_complete_now": "现在完成它并节省您下一次Pantry访问的时间。",
  "tefap_description": "通过紧急粮食援助计划 (TEFAP)，美国农业部向您当地的社区提供粮食支持，并通过施粥厨房和食品储藏室等社区机构向您提供粮食支持。",
  "tefap_what_is_tefap": "什么是tefap？",
  "tefap_confirm_share_with_pantry": "请确认您希望使用此储餐室分享以下信息。",
  "tefap_thanks_for_sharing": "感谢您提供食品室要求的其他信息！",
  "tefap_continue_make_reservation": "继续安排访问",
  "tefap_pantry_is_requesting": "这个食品室要求你的",
  "tefap_missing_information": "丢失的信息",
  "tefap_pantry_will_ask": "点击“下一步”立即添加此信息。如果您跳过此步骤，食品储藏室会在您下次访问时询问。",
  "tefap_submission_pending": "正在将您的答案提交给食品储藏室...",
  "cancel_edit": "取消编辑",
  "edit": "编辑",
  "select": "选择",
  "can_prepare_food": "可以准备食物",
  "cannot_prepare_food": "不能准备食物",
  "pantry_details_prompt_title": "需要 {{programName}}",
  "pantry_details_prompt_without_visit_label": "这个食品银行使用 {{programName}} 进行注册。当您到达食品银行时，您需要回答额外的问题。",
  "pantry_details_prompt_visit_label": "这个食品银行使用 {{programName}} 进行注册。在线回答这些问题以节省您下次访问的时间。",
  "state_program_attestation_cannot_complete": "抱歉，我们目前无法完成您的认证。您可以稍后再试、联系支持团队，或到达食品储藏室时完成此操作。",
  "state_program_attestation_submitted": "感谢您完成{{programName}}认证！您的回答已成功提交至食品储藏室。这结束了{{programName}}问题，任何进一步的提示都来自其他Plentiful程序。",
  "state_program_cancel_confirmation": "您确定要取消{{programName}}的认证吗？当您访问食品储藏室时，您可能仍需要回答这些问题。",
  "state_program_cancel_attestation": "取消认证",
  "state_program_resume_attestation": "继续认证",
  "tefap_no_submit": "不，提交",
  "tefap_yes_retake": "是的，夺回",
  "tefap_expires": "到期",
  "tefap_incomplete": "未完成，请立即完成，以节省您下次访问食品储藏室的时间",
  "tefap_none": "没有任何",
  "tefap_benefit_programs_select": "在以下程序中选择注册",
  "tefap_pantry_requests_info": "此食品室请求其他信息供您即将访问。",
  "tefap_eligible": "你有资格",
  "tefap_not_eligible": "你没有资格",
  "tefap_receive_product": "接收TEFAP产品",
  "tefap_eligible_program": "您参加以下计划",
  "tefap_eligible_programs": "您参加以下计划",
  "tefap_not_eligible_program": "您不参加任何程序",
  "tefap_household_income": "您的家庭收入",
  "tefap_info_changed": "最近有您的TEFAP资格信息（参与福利计划，家庭规模和/或收入）吗？",
  "tefap_still_get_food": "您仍然可以从肠内接收非TEFAP食品。",
  "tefap_form_checking_here": "通过检查此处，您证明以下是真实的：",
  "tefap_form_checking_1": "1.上面提供的收件人的姓名，地址和家庭规模是正确的。",
  "tefap_form_checking_2_CO": "2. 收件人居住在科罗拉多州（无最低居住时间要求）。",
  "tefap_form_checking_2_NY": "2.收件人居住在纽约州（不需要最低长度的居留程度）。",
  "tefap_form_checking_3": "3.收件人符合上述TEFAP资格指南的选项1和/或选项2。",
  "tefap_form_checking_4": "4.这种食物仅用于收件人的家庭消费，不会出售，交易或交换。",
  "tefap_form_checking_5_1": "5.收件人了解他们的公民权利如下所述",
  "tefap_form_checking_5_2": "USDA非歧视声明。",
  "tefap_out_of_state": "你生活在不同的状态",
  "and": "和",
  "or": "或者",
  "exceeds": "不在下面",
  "not_exceeds": "不超过",
  "people": "人们",
  "person": "人",
  "because": "因为",
  "custom_field_first_name": "名",
  "custom_field_last_name": "姓",
  "custom_field_contact_info": "联系信息",
  "custom_field_birth_date": "生日",
  "custom_field_zip_code": "邮政编码",
  "custom_field_household_size": "努力大小",
  "custom_field_food_pickup": "皮卡代表",
  "custom_field_emergency_contact": "紧急联系人",
  "custom_field_address": "地址",
  "custom_field_needs_assistance": "特殊情况（需要帮助）",
  "custom_field_benefits_programs": "福利计划",
  "custom_field_tefap_income_eligibility": "TEFAP收入资格",
  "custom_field_relationship_status": "关系状态",
  "custom_field_ethnicity": "种族",
  "custom_field_education": "获得最高的教育",
  "custom_field_dietary_preferences": "饮食偏好",
  "custom_field_gender": "性别",
  "custom_field_country_of_birth": "出生国",
  "custom_field_employment": "就业",
  "custom_field_food_preparation": "可以准备食物",
  "custom_field_housing": "住房状况",
  "search": "搜索（储藏室名称、邮编、城市、州）",
  "all": "全部",
  "pantry_filter_program_type": "节目类型",
  "pantry_filter_program_type_non-food": "非食物",
  "pantry_filter_program_type_foodpantry": "食品储藏室（免费杂货）",
  "pantry_filter_program_type_soupkitchen": "施粥厨房（免费热食）",
  "pantry_filter_status": "地位",
  "pantry_filter_status_all": "全部",
  "pantry_filter_status_opennow": "现在开门了",
  "pantry_filter_status_opentoday": "今天开放",
  "pantry_filter_status_openthisweek": "本周开放",
  "pantry_filter_status_other": "其他",
  "pantry_filter_pantry_type": "食品储藏室类型",
  "pantry_filter_pantry_type_plentifulpantry": "充足的食品储藏室",
  "pantry_filter_pantry_type_verifiedpartnerpantry": "经验证的合作伙伴食品储藏室",
  "pantry_filter_pantry_type_unverifiedpartnerpantry": "未经验证的合作伙伴食品储藏室",
  "search_no_results_found": "未找到结果",
  "search_no_pantries_match": "没有食品储藏室匹配\"{query}\"",
  "search_try_searching_by": "尝试搜索：",
  "search_suggestion_city": "城市名称（例如，\"布鲁克林\"）",
  "search_suggestion_city_accessibility": "城市名称，例如，布鲁克林",
  "search_suggestion_zipcode": "邮政编码（例如，\"10001\"）",
  "search_suggestion_zipcode_accessibility": "邮政编码，例如，10001",
  "search_suggestion_pantry_name": "食品储藏室名称",
  "search_suggestion_street_address": "街道地址",
  "search_accessibility_no_results": "未找到 {query} 的结果。尝试按城市名称、邮政编码、食品储藏室名称或街道地址搜索。",
  "search_accessibility_no_results_generic": "未找到结果。尝试按城市名称、邮政编码、食品储藏室名称或街道地址搜索。",
  "search_accessibility_no_results_sites": "未找到 {query} 的结果。请尝试按食品储藏室名称或城市搜索。",
  "search_accessibility_no_results_sites_generic": "未找到结果。请尝试按食品储藏室名称或城市搜索。",
  "search_error_unable_to_display": "无法显示搜索结果",
  "search_error_occurred": "显示搜索结果时发生错误。请重新搜索。",
  "search_results_truncated": "正在显示最佳结果。如果没有找到您需要的内容，请尝试其他搜索词。",
  "accessibility_phone": "电话：{phone}",
  "accessibility_email": "电子邮件：{email}",
  "accessibility_website": "网站：{website}",
  "pantry_filter_service_type": "服务类型",
  "pantry_filter_service_type_line": "基于线路",
  "pantry_filter_service_type_pre-registration": "预登记",
  "pantry_filter_service_type_qr-code": "二维码签到",
  "pantry_filter_service_type_reservation": "预订",
  "program_type_benefit_enrollment": "福利注册",
  "program_type_emergency_services": "紧急服务",
  "program_type_non_plentiful_pantry": "非娱乐储藏室",
  "program_type_other_services": "其他服务",
  "program_type_plentiful_pantry": "充足的食品储藏室",
  "program_type_shelter": "庇护所",
  "program_type_soup_kitchen": "汤厨房",
  "service_restriction_none": "没有限制",
  "service_restriction_seniors": "只有老年人",
  "service_restriction_families_with_children": "只有孩子的家庭",
  "service_restriction_new_clients": "仅新客户",
  "service_restriction_existing_clients": "仅现有客户",
  "filter_by_category": "按类别过滤",
  "opted_out": "看来您的电话号码选择了SMS，因此我们无法向您发送登录代码。请通过发短信 START 到726879选择回去，然后重试",
  "miles_away_singular": "%s英里外",
  "miles_away_plural": "%s英里外",
  "today": "今天",
  "address_autocomplete_placeholder": "开始输入以查看建议",
  "push_notification_permissions_denied": "未授予推送通知权限。请打开系统设置并启用推送通知。",
  "push_notification_setup_error": "设置推送通知时出错。",
  "push_notification_alternate_notifications": "您仍将通过短信或电子邮件收到通知。",
  "loading_message": "寻找您附近的食物救济站",
  "location_services_no_access": "Plentiful 似乎无法访问您设备的位置信息。请在您的浏览器或设备设置中启用 Plentiful 的定位服务",
  "error_screen_header": "哎呀！出错了。",
  "error_screen_message": "我们遇到了意外问题。您可以尝试重启应用或联系客服。",
  "update_available_header": "有可用更新",
  "update_available_message": "请重启以加载最新版本。",
  "restart_app": "重新启动应用程序",
  "email_support": "电子邮件支持",
  "map_zoom_to_see_all": "放大以查看所有位置",
  "program_eligible": "您符合参加{{program}}项目的资格。",
  "program_ineligible": "您不符合参加{{program}}项目的资格：{{reason}}",
  "program_not_applicable": "您已完成 {{program}}。",
  "program_completed": "您已完成所有 {{program}} 问题。",
  "program_unknown_eligibility": "感谢您填写表格。您到达后，服务提供商将确定您的资格。",
  "site_map_error_title": "出错了",
  "site_map_error_message": "无法加载地图。请重试。",
  "site_map_load_error_title": "无法加载站点",
  "site_map_load_error_message": "加载该区域时出错。请重试。",
  "site_map_retry": "重试",
  "site_list_search_placeholder": "Search pantry name, ZIP, city",
  "site_list_result_count": "{{count}}个地点",
  "site_list_result_count_one": "{{count}}个地点",
  "site_list_result_count_zero": "未找到地点",
  "site_list_today": "Today",
  "site_list_tomorrow": "Tomorrow",
  "site_list_status_open_until": "Open now until {{time}}",
  "site_list_status_open_now": "现在营业中",
  "site_list_status_closed_next_open": "Closed now · next open {{day}} {{time}}",
  "site_list_status_no_upcoming": "No upcoming services",
  "site_list_status_more_available": "可能还有更多时间段 · 请联系食品储藏室",
  "site_list_booking_walkin": "Walk in",
  "site_list_booking_reservation": "Reservation",
  "site_list_booking_preregistration": "Pre-registration",
  "site_list_booking_unknown": "未知",
  "site_list_more_times": "+ more times available",
  "site_list_default_event_name": "Food Distribution",
  "site_list_unconfirmed_title": "Hours not confirmed",
  "site_list_unconfirmed_body": "We list this place from a partner directory but don't have its current times. Call before you go.",
  "site_list_timezone_note": "显示时间为{{zone}}",
  "site_details_upcoming_events_heading": "即将推出的服务",
  "site_details_reserve_cta": "预约时间",
  "site_details_plan_visit_cta": "计划您的访问",
  "site_details_no_upcoming_events": "暂无即将推出的服务",
  "site_details_timezone_note": "显示时间为{{zone}}",
  "site_details_more_windows": "+ 更多可用时间",
  "site_details_event_name_fallback": "分发",
  "site_details_slot_picker_no_times": "没有可用时间",
  "site_details_slot_full": "已满",
  "site_details_availability_as_of": "截至 {{time}} 的可预约情况",
  "site_details_availability_error": "无法加载时间，请重试。"
}
